module.exports = __webpack_public_path__ + "img/c3.c8b2ab03.png";